import { useParams } from 'react-router-dom';
import { useGetModuleSpecsQuery } from '../../../../api/queries/getModuleSpecs';
import { ModuleType } from '../../../../api/types';
import LoadingElement from '../../../../components/LoadingElement';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import UpdateTtbPaymentSettingInnerPage from './UpdateTtbPaymentSettingInnerPage';

const UpdateTtbPaymentSettingPage = () => {
    const { moduleId, paymentSettingId } = useParams<{ moduleId: string; paymentSettingId: string }>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-first',
        variables: { moduleId },
    });

    if (!data && !loading) {
        return <NotFoundResult />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    const { module } = data;

    if (module.__typename !== ModuleType.TtbPaymentModule) {
        return <NotFoundResult />;
    }

    const paymentSetting = module.paymentSettings.find(item => item.id === paymentSettingId);

    if (!paymentSetting) {
        return <NotFoundResult />;
    }

    return <UpdateTtbPaymentSettingInnerPage module={module} paymentSettings={paymentSetting} />;
};

export default UpdateTtbPaymentSettingPage;
